import {StyleSheet} from "aphrodite";
import * as React from "react";

import BasePageTemplate, {
    type BasePageTemplateProps,
} from "./base-page-template.tsx";

/**
 * Provides a page template for that simulates a full-screen experience, excluding
 * the site footer.
 */
const HeaderOnlyPageTemplate = ({
    children,
    containerStyle,
    ...restProps
}: BasePageTemplateProps): React.ReactElement => {
    return (
        <BasePageTemplate
            {...restProps}
            showFooter={false}
            containerStyle={[styles.container, containerStyle]}
            mainContentStyle={styles.mainContent}
        >
            {children}
        </BasePageTemplate>
    );
};

const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
    },
    mainContent: {
        flex: 1,
        overflow: "hidden",
    },
});

export default HeaderOnlyPageTemplate;
